import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccessControlService } from '../../services/access-control.service';
import { WebhookService } from '../../services/webhook.service';
import Swal from 'sweetalert2';

type Link = { url: string, active: boolean, application_id: string, label: string, position: string }
@Component({
  selector: 'app-add-links',
  templateUrl: './add-links.component.html',
  styleUrls: ['./add-links.component.css']
})
export class AddLinksComponent implements OnInit {
  model: Array<Link> = [];// { _id: null, url: null, active: false, type: HookType.POST_USER_CREATION };
  application_name: string;
  appId: string;
  clientId: string;
  reqStatus: string;
  saveStatus: string = "Save";
  index: number;
  applicationList: Array<{ application_name: string, _id: string }>;
  isLoading = false;

  @ViewChild("containerRef", { read: ViewContainerRef }) containerRef: ViewContainerRef;
  @ViewChild("linkTemplate", { read: TemplateRef }) templateRef: TemplateRef<any>;
  isSaving: boolean;
  constructor(private router: ActivatedRoute, private webhookService: WebhookService, private toastrService: ToastrService, private accessControlService: AccessControlService) {
    this.router.queryParams.subscribe((params: Params) => {
      this.application_name = params["appname"];
    })
    this.router.params.subscribe((params: Params) => {
      this.appId = params["applicationId"];
    });
    this.clientId = localStorage.getItem("org_id");
    this.accessControlService.getClient(this.clientId, 0).subscribe((res: any) => {
      if (!res.error) {
        this.applicationList = res.data['applications'];
      }
    })
    this.getLinks();
  }

  ngOnInit() {
  }
  getLinks() {
    this.isLoading = true;
    this.accessControlService.getLinks( this.appId,this.clientId ).
      subscribe((res: any) => {
        if (!res.error && res.data.hyperLinks.length > 0)
          this.model = res.data.hyperLinks;
        if (this.model.length == 0) {
          this.model.push({ url: null, active: false, application_id: null, label: null, position: null });
        }
        if (this.model.length > 0) {
          this.renderLinks();
        }
        this.isLoading = false;

      }, error => {
        this.isLoading = false;

      });
  }
  saveLink() {
    this.saveStatus = "Saving.."
    this.isSaving=true;
    this.accessControlService.saveLink(this.model, this.appId, this.clientId).
      subscribe(
        (result: any) => {

          if (!result.error) {
            this.toastrService.success("Setting saved successfully")
            this.saveStatus = 'save'
            this.isSaving=false;

          }
        },
        (error: any) => {

          var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
          this.toastrService.error(errorMessage)
          this.saveStatus = 'save'
          this.isSaving=false;
        },

      )


  }

  addLink() {
    this.model.push({ url: null, active: false, application_id: null, label: null, position: null });
    this.containerRef.createEmbeddedView(this.templateRef, { model: this.model, index: this.model.length - 1 });
  }
  renderLinks() {
    this.model.forEach((link, index) => {
      this.containerRef.createEmbeddedView(this.templateRef, { model: this.model, index: index });
    })
  }
  onDelete(index) {
    Swal({
      title: 'Are you sure you want to delete?',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.model.splice(index, 1);
        this.containerRef.remove(index);
      }

    })

  }

}
